import React, { createContext, useContext, useState, ReactNode, useMemo } from 'react';

interface GradingState {
  roleplayId: string;
  roleplayName: string;
  dateCompleted: string;
  status: 'completed' | 'in-progress' | 'not-started';
}

interface GradingContextType {
  gradingState: GradingState | null;
  setGradingState: (state: GradingState | null) => void;
}

const GradingContext = createContext<GradingContextType | undefined>(undefined);

export const useGrading = () => {
  const context = useContext(GradingContext);
  if (context === undefined) {
    throw new Error('useGrading must be used within a GradingProvider');
  }
  return context;
};

interface GradingProviderProps {
  children: ReactNode;
}

export const GradingProvider: React.FC<GradingProviderProps> = ({ children }) => {
  const [gradingState, setGradingState] = useState<GradingState | null>(null);

  const value = useMemo(() => ({ gradingState, setGradingState }), [gradingState]);

  return (
    <GradingContext.Provider value={value}>
      {children}
    </GradingContext.Provider>
  );
};